import styled from 'styled-components';
import logo from '../../../assets/gif/logo.gif';

export const Content = styled.div`
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 1rem;
    padding: 2.4rem;
    min-height: 25rem;
`;

export const LogoGif = styled.img.attrs({ alt: 'logo', src: logo })`
    width: 16.4rem;
    height: 16.4rem;

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        width: 10.8rem;
    }
`;
